(function () {
  /* Modelpagina: tellers die oplopen en blokken die verschijnen bij het scrollen. Zonder script of met minder beweging blijft alles gewoon zichtbaar. */
  if (window.__swModelPage) return;
  window.__swModelPage = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('sw-anim');

  function format(n, decimals) {
    try {
      return n.toLocaleString('nl-NL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    } catch (e) {
      return n.toFixed(decimals);
    }
  }

  function prepare(counter) {
    var target = parseFloat(counter.getAttribute('data-target'));
    if (isNaN(target)) return;
    var decimals = parseInt(counter.getAttribute('data-decimals'), 10) || 0;
    counter.textContent = format(0, decimals);
  }

  function run(counter) {
    var target = parseFloat(counter.getAttribute('data-target'));
    if (isNaN(target)) return;
    var decimals = parseInt(counter.getAttribute('data-decimals'), 10) || 0;
    var final = counter.getAttribute('data-final');
    var duration = 1600;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      counter.textContent = format(target * eased, decimals);
      if (p < 1) window.requestAnimationFrame(step);
      else counter.textContent = final || format(target, decimals);
    }
    window.requestAnimationFrame(step);
  }

  var counters = Array.prototype.slice.call(document.querySelectorAll('.sw-count'));
  counters.forEach(prepare);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-in');
      var counter = el.querySelector ? el.querySelector('.sw-count') : null;
      if (counter) run(counter);
      observer.unobserve(el);
    });
  }, { threshold: 0.18 });

  Array.prototype.forEach.call(document.querySelectorAll('.sw-reveal'), function (el) { observer.observe(el); });
})();
